import { render } from "./BajaInscripcion.vue?vue&type=template&id=fcf523dc&scoped=true&ts=true"
import script from "./BajaInscripcion.vue?vue&type=script&lang=ts"
export * from "./BajaInscripcion.vue?vue&type=script&lang=ts"

import "./BajaInscripcion.vue?vue&type=style&index=0&id=fcf523dc&scoped=true&lang=css"
import "./BajaInscripcion.vue?vue&type=style&index=1&id=fcf523dc&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf523dc"]])

export default __exports__